/**
 * Las direcciones de los documentos legales, aparte de los documentos.
 *
 * Viven solas porque el pie del panel enlaza a ellos desde todas las pantallas:
 * importar `registry.ts` para sacar una dirección arrastraba al paquete
 * principal el texto entero de los doce documentos, que sólo se necesita al
 * abrir uno. El registro lee estas mismas direcciones, así que hay una sola.
 */
import type { LegalSlug } from './types'

export type LegalLanguage = 'es' | 'en'

export const LEGAL_PATHS: Record<LegalSlug, Record<LegalLanguage, string>> = {
  terms: { es: '/terminos', en: '/terms' },
  privacy: { es: '/privacidad', en: '/privacy' },
  aup: { es: '/uso-aceptable', en: '/acceptable-use' },
  cookies: { es: '/cookies', en: '/cookie-policy' },
  copyright: { es: '/derechos-de-autor', en: '/copyright' },
  billing: { es: '/facturacion', en: '/billing-policy' },
  sellers: { es: '/terminos-ventas', en: '/seller-terms' },
  domains: { es: '/terminos-dominios', en: '/domain-terms' },
  ai: { es: '/terminos-ia', en: '/ai-terms' },
  beta: { es: '/terminos-beta', en: '/beta-terms' },
  dpa: { es: '/dpa', en: '/dpa' },
  subprocessors: { es: '/subprocesadores', en: '/subprocessors' },
}
